import actionCreator from 'helpers/actionCreator'
import { NOTIFICATION, ADD_NOTIFICATION, REMOVE_NOTIFICATION } from 'actions/notificationActionTypes'

/** Called as an action when starting to add a notification */
export const notificationAction = actionCreator(NOTIFICATION, 'message', 'notificationType')

/** Called as an action when adding a notification */
export const addNotificationAction = actionCreator(ADD_NOTIFICATION, 'message', 'notificationType')

/** Called as an action when removing a notification */
export const removeNotificationAction = actionCreator(REMOVE_NOTIFICATION)



// WEBPACK FOOTER //
// ./src/actions/notificationActions.js